import GoogleTagAdapter from "components/shared/GoogleTagAdapter/GoogleTagAdapter";
import GooglePublisherTag from "components/shared/GooglePublisherTag/GooglePublisherTag";
import BannerAdTracker from "components/shared/BannerAdTracker/BannerAdTracker";

window.GoogleTagAdapter = GoogleTagAdapter;
window.GooglePublisherTag = GooglePublisherTag;
window.BannerAdTracker = BannerAdTracker;